import styled from 'styled-components';
import css from '@styled-system/css'

import { GridContainer } from '../grid-container';
import Markdown from '../markdown';
import { linkVariants } from '../link/link-base';

export const Wrapper = styled(GridContainer)`
  ${props => css({
    backgroundColor: props.backgroundColor || 'magic.base'
  })}
`

export const Message = styled(Markdown)`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 4px 0;
  color: ${(props) => props.theme.colors.white};

  // Overwrites the markdown class specificity
  &&&& a {
    ${(props) => linkVariants(props)({ variant: 'white' })};
  }
`;
